class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsHost = this.querySelector("#predictive-search");
    this.clearBtn = this.querySelector("[data-clear]");

    // The empty state (quick links) is rendered server-side by
    // snippets/predictive-search-quick-links.liquid; keep a copy so clearing
    // the query restores it without a request.
    this.initialHTML = this.resultsHost.innerHTML;

    this.handleInput = debounce(this.onInput.bind(this), 220);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.input.addEventListener("input", this.handleInput);
    this.input.addEventListener("keydown", this.onKeyDown);
    if (this.clearBtn)
      this.clearBtn.addEventListener("click", () => {
        this.input.value = "";
        this.showInitialState();
        this.input.focus();
      });
  }

  setExpanded(open) {
    this.input.setAttribute("aria-expanded", open ? "true" : "false");
  }

  updateResults(html, updateSubmenuHeight = true) {
    this.resultsHost.innerHTML = html || "No results found";
    if (updateSubmenuHeight) window.updateSubmenuHeight();
    this.resultsHost.classList.remove("opacity-0");
    this.resultsHost.classList.add("opacity-100");
  }

  showInitialState() {
    this.updateResults(this.initialHTML, false);
  }

  // Fetch the predictive-search section for a query (Section Rendering API) and
  // swap its markup into the panel.
  async runSearch(q) {
    this.setExpanded(true);

    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    const params = new URLSearchParams({
      q,
      "resources[type]": "query,product,collection,page,article",
      section_id: "predictive-search",
    });

    let html = "";
    try {
      this.resultsHost.classList.add("opacity-0");
      this.resultsHost.classList.remove("opacity-100");
      const res = await fetch(`${root}search/suggest?${params.toString()}`, {
        headers: { Accept: "text/html" },
      });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "text/html");
      html =
        doc.querySelector("#shopify-section-predictive-search")?.innerHTML ||
        "";
    } catch (e) {
      html = "";
    }

    this.updateResults(html);
  }

  async onInput() {
    const q = this.input.value.trim();
    if (!q || q.length < 1) {
      this.showInitialState();
      return;
    }

    await this.runSearch(q);

    this.items = Array.from(
      this.resultsHost.querySelectorAll(
        '[role="option"] a, [role="option"] button, [role="option"]'
      )
    );
    this.activeIndex = -1;
  }

  onKeyDown(e) {
    if (!this.resultsHost.innerHTML.trim()) return;

    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      if (!this.items || !this.items.length) return;
      const dir = e.key === "ArrowDown" ? 1 : -1;
      this.activeIndex =
        ((this.activeIndex ?? -1) + dir + this.items.length) %
        this.items.length;
      const el = this.items[this.activeIndex];
      el.focus({ preventScroll: true });
      el.scrollIntoView({ block: "nearest" });
    }

    if (e.key === "Escape") {
      this.showInitialState();
      this.input.focus();
    }
  }
}

if (!customElements.get("predictive-search")) {
  customElements.define("predictive-search", PredictiveSearch);
}
